import {
  ExperienceDto,
  ExperienceListDto,
  OrganizationDto,
} from "@intelligems/ig-types";
import { useGetExperiences } from "@src/api/experiences/get-experiences";
import { useGetExperiencesList } from "@src/api/experiences-list/get-experiences-list";
import { useGetOrg } from "@src/api/organizations/get-organization";

const checkOfferLimit = (
  organization: OrganizationDto,
  offerExperiences?: ExperienceDto[],
  experimentList?: ExperienceListDto[]
): boolean => {
  const orgLimit = organization.configurations.find(
    (config) => config.key === "max_enabled_offers"
  );

  const maxEnabledOffers: number = (orgLimit?.value ?? 15) as number;

  const combinedExperiences = [
    ...(offerExperiences || []),
    ...(experimentList || []),
  ];

  const enabledOfferExperiences = combinedExperiences.filter(
    (experience) =>
      (experience.status === "started" ||
        experience.status === "paused" ||
        experience.status === "pending") &&
      experience.archivedAtTs === null
  );

  let totalOffers = 0;
  enabledOfferExperiences.forEach((experience) => {
    if (experience.variations) {
      experience.variations.forEach((variation) => {
        if (variation.offerId) {
          totalOffers += 1;
        }
      });
    }
  });

  // Compare total offers with the organization limit
  return totalOffers <= maxEnabledOffers;
};

export const useIsUnderOfferLimit = () => {
  const org = useGetOrg();
  const offerExperiencesData = useGetExperiences("offerPersonalization");
  const experimentListData = useGetExperiencesList({
    category: "experiment",
  });

  // `isUnderLimit` is fully derived from the query results, so compute it during
  // render rather than mirroring it into local state via useEffect + setState.
  // The query hooks (useInfiniteQuery + select) return a fresh result object on
  // every render, so an effect depending on those objects re-ran — and re-set
  // state — on every render, driving an infinite update loop ("Maximum update
  // depth exceeded"). Deriving during render removes the loop entirely; the
  // React Compiler memoizes the computation.
  if (!offerExperiencesData.isSuccess || !experimentListData.isSuccess) {
    return true;
  }

  return checkOfferLimit(
    org.data.org,
    offerExperiencesData.data?.experiences || [],
    experimentListData.data?.experiencesList
  );
};
